import { PageSubtitle } from "@components/common/page-subtitle";
import { TextProps } from "@flat-ui";
import { QueryParams } from "@router/route-params";
import { useSearchParams } from "react-router-dom";

interface Props {
  /** Optional style props to pass to the component */
  sx?: TextProps["sx"];
}

/**
 * Renders the subtitle for the invited user registration page.
 */
export function InvitedSubtitle({ sx }: Props): JSX.Element {
  const [searchParams] = useSearchParams();
  const companyName = searchParams.get(QueryParams.company);

  return (
    <PageSubtitle sx={sx}>
      {"Complete your account to join "}
      {companyName ? (
        <b>
          <var>{companyName}</var>
        </b>
      ) : (
        "the workspace"
      )}
    </PageSubtitle>
  );
}
